import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import {
  DataContextBuilder,
  IDataContext,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderDataToolbarComponent,
  ElderToolbarContentDirective,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
} from '@elderbyte/ngx-starter'
import { Router } from '@angular/router'
import { Property } from '../../../properties/property'
import { VendorService } from '../vendor.service'
import { Vendor } from '../../vendor'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatIcon } from '@angular/material/icon'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'
import { MatSort, MatSortHeader } from '@angular/material/sort'

@Component({
  selector: 'app-vendor-browser',
  templateUrl: './vendor-browser.component.html',
  styleUrls: ['./vendor-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class VendorBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)
  public readonly data: IDataContext<Vendor>
  private router = inject(Router)
  private vendorService = inject(VendorService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.data = DataContextBuilder.start<Vendor>()
      .pageSize(30)
      .reloadOnLocalChanges()
      .autoStartAsap()
      .build(this.vendorService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(property: Property): void {
    this.router.navigate([{ outlets: { side: ['vendors', property.id] } }], {
      preserveFragment: true,
    })
  }

  public create(): void {
    this.router.navigate([{ outlets: { side: ['vendors', 'new'] } }], { preserveFragment: true })
  }
}
